import RegisterCustomer from '@/services/users/registrationService/RegisterCustomer';
import ValidateDelivery from '@/services/users/registrationService/ValidateDelivery';
import ValidateIntroductions from '@/services/users/registrationService/ValidateIntroductions';
import RegisterCanvassedCustomer from '@/services/users/registrationService/RegisterCanvassedCustomer';

export default class RegistrationService {
    /**
     * Handle registering a new WEB customer.
     *
     * @param {String} tokenId
     * @param {String} cardId
     *
     * @returns {Promise}
     */
    static registerCustomer(tokenId, cardId, paymentMethod, nameOfCard) {
        return (new RegisterCustomer()).handle(tokenId, cardId, paymentMethod, nameOfCard);
    }

    /**
     * Handle registering a new WEB customer.
     *
     * @param {String|null} tokenId
     * @param {String|null} cardId
     *
     * @returns {Promise}
     */
    static registerCanvassedCustomer(tokenId = null, cardId = null, customer = null) {
        return (new RegisterCanvassedCustomer()).handle(tokenId, cardId, customer);
    }

    /**
     * Handle validating the introductions step of the registration.
     *
     * @returns {Promise}
     */
    static validateIntroductions() {
        return (new ValidateIntroductions()).handle();
    }

    /**
     * Handle validating the delivery step of the registration.
     *
     * @returns {Promise}
     */
    static validateDelivery() {
        return (new ValidateDelivery()).handle();
    }
}
